window.app.run([
  function() {
    var enabled = false;

    if (!enabled || window.location.origin == "http://localhost:9002") {
      return;
    }

    var messageBufferSize = 1000;
    var messages = new Array(messageBufferSize);
    var messageIdx = 0;

    console.replay = function() {
      return messages
        .slice(0, messageIdx + 1)
        .concat(messages.slice(messageIdx, messageBufferSize - messageIdx))
        .map(function(msg) {
          return msg.join(" ");
        })
        .join("\n")
        .trim();
    };

    makeWrapper("log");
    makeWrapper("error");
    makeWrapper("warn");
    makeWrapper("info");
    makeWrapper("debug");
    makeWrapper("dir");

    function makeWrapper(type) {
      var nativeFunc = console[type];
      console[type] = function() {
        var msg = Array.prototype.slice.call(arguments).map(function(arg) {
          try {
            return JSON.stringify(arg);
          } catch (e) {
            return "" + arg;
          }
        });
        // eslint-disable-next-line no-caller
        msg.splice(0, 0, new Date().toJSON(), type, arguments.callee.name);
        messages[messageIdx] = msg;

        if (++messageIdx == 1000) {
          messageIdx = 0;
        }
        return nativeFunc.apply(console, arguments);
      };
    }
  }
]);



// WEBPACK FOOTER //
// ./src/services/consoleRecorder.js